import React from "react";
import moment from "moment";
import logoDownload from "../Resources/img/icon-download-file.svg";
import { CSVLink } from "react-csv";

const TableDecisionRules = ({ items ,type}) => {
  return (
    <div className="md-g-wapper__container__table">
      <table align="center">
        <thead>
          <tr>
            <th
              data-field="nro"
              className="md-g-wapper__container__table__item"
            >
              N°
            </th>
            <th
              data-field="creationDate"
              className="md-g-wapper__container__table__item"
            >
              Fecha de creación
            </th>
            <th
              data-field="name"
              className="md-g-wapper__container__table__item"
            >
              Nombre del archivo
            </th>
            <th
              data-field="options"
              className="md-g-wapper__container__table__item"
            >
              Opciones
            </th>
          </tr>
        </thead>
        <tbody>
          {Array.isArray(items) && items.map((value, key) => {
            return (
              <tr key={key}>
                <td className="md-g-wapper__container__table__item">
                  {key + 1}
                </td>
                <td className="md-g-wapper__container__table__item">
                  {moment(value.creationDate).format("DD/MM/YYYY HH:mm:ss")}
                </td>
                <td className="md-g-wapper__container__table__item">
                  {value.name}
                </td>
                <td className="md-g-wapper__container__table__item">
                  <div className="md-g-wapper__container__table__item__link">
                    <img src={logoDownload} alt="logoDownload"/>
                    {
                      type === 'csv' ? <CSVLink filename={value.name} data={value.fileContent}>Descargar CSV</CSVLink> :
                      <><a target='_blank' rel="noopener noreferrer" href={value.url}>Descargar PDF</a></>
                    }
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default TableDecisionRules;
